import styled from '@emotion/styled';
import { CardItem } from '@shared/components/core/text/CardTypography';
import { ChipSmall } from '@shared/components/core/text/Typography';
import { borderRadius } from '@shared/constants/Styles';
import PageBannerCard from './PageBannerCard';

export const CardBorder = styled.div`
    border-radius: 0.375rem;
    border: 1px solid ${(props) => props.theme.color.border};
`;

export const CardStackWrap = styled.div`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    padding: 0.75rem 0;
    > svg {
        padding-top: 1rem;
    }
    &:not(:last-of-type) {
        border-bottom: 1px solid ${(props) => props.theme.color.border};
    }
`;

export const SimpleCardStackWrap = styled.div`
    display: flex;
    gap: 0.5rem;
    &:not(:last-of-type) {
        border-bottom: 1px solid ${(props) => props.theme.color.border};
    }
`;

export const CardSmall = styled.div`
    position: relative;
    width: 16rem;
    min-height: 16rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    border-radius: 0.375rem;
    border: 1px solid ${(props) => props.theme.color.border};
`;

export const CardMedium = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2.25rem;
    gap: 0.5rem;
    border-radius: 0.375rem;
    width: 24.625rem;
    max-width: 100vw;
    border: 1px solid ${(props) => props.theme.input.background};
    background: ${(props) => props.theme.color.background};
`;

export const CardLarge = styled.div`
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    padding: 2.25rem;
    gap: 0.5rem;
    border-radius: 0.375rem;
    background: ${(props) => props.theme.color.background};
`;

export const IconWrap = styled.div`
    padding: 1.25rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 10rem;
`;

// 16:9 media header for a card: a relative, centered container that hosts a cover image or a
// fallback icon, with room for absolutely-positioned overlay ("prefix") items. See CardMedia.
export const CardMediaHeader = styled.div`
    position: relative;
    flex: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: ${(props) => props.theme.color.accentCard};
    border-bottom: 1px solid ${(props) => props.theme.color.border};
`;

export const InlineTagNodeWrap = styled.div`
    margin: 0;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`;

export const WrapCardText = styled.div`
    flex-basis: 100%;
    padding: 1.25rem 1.25rem 1.75rem 1.25rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
`;

export const ButtonWrap = styled.div`
    justify-self: space-between;
    align-self: stretch;
    flex-grow: 1;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: flex-end;
    align-items: stretch;
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`;

export const ButtonRowCenter = styled(ButtonRow)`
    justify-content: center;
    margin: 1rem 0 2rem 0;
`;

export const ProfileTitleWrap = styled.div`
    margin-bottom: 0.5rem;
`;

export const StatusChip = styled(ChipSmall)`
    position: absolute;
    top: -0.8rem;
    left: 50%;
    transform: translateX(-50%);
`;

export const FeatureItem = CardItem.withComponent('li');

export const FeaturesWrap = styled.ul`
    padding: 10px;
    columns: 2;
`;

export const AccentPageBannerCard = styled(PageBannerCard)`
    border-radius: 0.375rem;
    background: ${(props) => props.theme.color.accentCard};
    margin-top: 2rem;
    margin-bottom: 2rem;
`;

export const FeatureCard = styled(CardBorder)<{ $accent: string }>`
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 100%;
    max-width: 1200px;
    margin: 1rem auto 0 auto;
    padding: 1.5rem;
    gap: 1rem;
    border-left: 3px solid ${({ $accent }) => $accent};
    background-color: ${(props) => props.theme.color.card};
    border-radius: ${borderRadius.micro} ${borderRadius.md} ${borderRadius.md} ${borderRadius.micro};
`;
